/**
 * Hero Carousel Data
 * ---------------------------------------------------------
 * To add a new slide, append an object to the array below.
 * Each slide must have:
 *   - title       : string  — headline shown on the left
 *   - description : string  — body text shown below the title
 *   - image       : string  — path to the image file.
 *   - imageWidth / imageHeight : original image dimensions, used to reserve
 *                                space before the image loads.
 *                             Place your image inside:
 *                               public/carousel/
 *                             then reference it as:
 *                               "/carousel/your-image.png"
 *
 * Example:
 * {
 *   title: "My New Event",
 *   description: "Short description of what happened.",
 *   image: "/carousel/my-new-event.jpg"
 * }
 * ---------------------------------------------------------
 */

export const slides = [
  
  {
    title: "Reforms Utsav at Bharat Mandapam",
    description: "NMDFC participated in the Reforms Utsav, celebrating 12 years of transformative governance and advancing AI-led digital transformation through an MoU with EkStep Foundation.",
    image: "/carousel/reforms utsav1.jpg.jpeg",
    imageWidth: 1002,
    imageHeight: 491,
  },
  {
    title: "National Conclave on Minorities Welfare",
    description: "NMDFC joined the National Conclave to explore the transformative role of Artificial Intelligence in governance, skill development, and citizen-centric services.",
    image: "/carousel/AI.jpeg",
    imageWidth: 456,
    imageHeight: 228,
  },
  {
    title: "Capacity Building Programme for Channel Partners",
    description: "Organized under the theme #BhagidariSeBhagyoday, this programme aimed to strengthen channel partners and promote financial inclusion across the country.",
    image: "/carousel/CBP1.jpg.jpeg",
    imageWidth: 1045,
    imageHeight: 699,
  },
  {
    title: "National ‘Chintan Shivir’ at Nalanda University",
    description: "NMDFC participated in the National ‘Chintan Shivir’ to deliberate on a policy-driven roadmap for minority welfare, aligned with the vision of Viksit Bharat.",
    image: "/carousel/meeting.png",
    imageWidth: 658,
    imageHeight: 485,
  },

  {
    title: "77th Republic Day Celebrations",
    description: "As special guests, 100 NMDFC beneficiaries and their families attended the Republic Day Parade, reflecting our commitment to empowering minority communities.",
    image: "/carousel/RepDay6.jpg.jpeg",
    imageWidth: 901,
    imageHeight: 601,
  }
];
